import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageFilter } from '@common/paged-data/types/page-filter.type';
import { Page } from '@common/paged-data/types/page.type';
import { ApiService } from '@portal-core/auth/services/api.service';
import { ChecklistTemplate } from '@portal-core/checklist-templates/models/checklist-template.model';
import { SharePendingRequest } from '@portal-core/util/observables.decorators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChecklistTemplatesApiService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  @SharePendingRequest()
  getChecklistTemplatesByLicenseId$(licenseId: number): Observable<ChecklistTemplate[]> {
    return this.http.get<ChecklistTemplate[]>(`${this.apiService.centralApiBaseUri}/api/checklists/templates/license/${licenseId}`);
  }

  @SharePendingRequest()
  getChecklistTemplatesPage$(licenseId: number, filter?: PageFilter): Observable<Page<ChecklistTemplate>> {
    return this.http.post<Page>(`${this.apiService.centralApiBaseUri}/api/checklists/templates/license/${licenseId}`, filter);
  }

  @SharePendingRequest()
  verifyChecklistTemplateName$(licenseId: number, checklistTemplateName: string): Observable<any> {
    return this.http.get<boolean>(`${this.apiService.centralApiBaseUri}/api/checklists/templates/license/${licenseId}/verifyChecklistTemplateName?checklistTemplateName=${encodeURIComponent(checklistTemplateName)}`);
  }

  upsertChecklistTemplate$(template: ChecklistTemplate): Observable<any> {
    return this.http.put(`${this.apiService.centralApiBaseUri}/api/checklists/templates/upsert`, template);
  }

  deleteChecklistTemplate$(templateId: number): Observable<any> {
    return this.http.delete(`${this.apiService.centralApiBaseUri}/api/checklists/templates/${templateId}`);
  }
}
